module.exports = __webpack_public_path__ + "static/media/PitchPerfect.69e51514.jpg";